import { ReactComponent as ChatGptIcon } from 'Images/openai.svg';

import {
  BLOCK_UNSUPPORTED,
  CLIENT_STATUS_UNSUPPORTED
} from './constants';

const chatGpt = {
  id: 'chatGpt',
  label: 'ChatGPT',
  icon: ChatGptIcon,
  status: CLIENT_STATUS_UNSUPPORTED,
  authMethods: [],
  summaryId: 'mcp.client.chatGpt.summary',
  buildSections: () => [
    {
      id: 'unsupported',
      blocks: [
        {
          id: 'reason',
          type: BLOCK_UNSUPPORTED,
          textId: 'mcp.client.chatGpt.reason',
          alternatives: ['claudeCode', 'claudeDesktop', 'vsCode', 'cursor', 'cline']
        }
      ]
    }
  ]
};

export default chatGpt;
